import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostCrecaAccountsRequestModel, PostCrecaAccountsResponseModel } from "@/features/accounts/creca/services/post-accounts-model";

export class PostCrecaAccountsApi {
  /**
   * クレカ登録API
   */
  public postCrecaAccounts = async (
    param: PostCrecaAccountsRequestModel
  ): Promise<PostCrecaAccountsResponseModel[]> => {
    const path = `/api/crecaaccounts/crecas`;
    const res = await ApiClient.instance.post<PostCrecaAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
